import { request } from './api.js';
import type { PurchaseDailyResponse } from '../types/purchase-analysis.js';

/** @graph-connects none */
function dateRangeUrl(path: string, from?: string, to?: string): string {
  const qs = new URLSearchParams();
  if (from) qs.set('from', from);
  if (to) qs.set('to', to);
  const query = qs.toString();
  return query ? `${path}?${query}` : path;
}

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Finance
 * @graph-business 購入分析 API クライアント。日次の購入率・購入単価・購入着数・購入売上の推移を取得する。
 * @graph-connects /purchase-analysis/daily [calls] 購入分析日次集計
 */
export const purchaseAnalysisApi = {
  getDaily: (params?: { from?: string; to?: string }): Promise<PurchaseDailyResponse> =>
    request(dateRangeUrl('/purchase-analysis/daily', params?.from, params?.to)),
};
